import React from "react";

const LinksFilterTabs = ({ all, a, d, active, setActiveTab }) => {
  return (
    <div className="flex md:mt-32px mt-20px gap-16px border-b border-primary-100 dark:border-accent-700 text-sm font-medium text-accent-500">
      <div
        onClick={() => setActiveTab("All")}
        className={`cursor-pointer px-1 pb-10px flex items-center gap-8px
    ${
      active === "All"
        ? "text-primary-500 border-b-[3px] border-primary-500"
        : "dark:text-accent-300"
    }`}
      >
        All{" "}
        <span
          className={`w-[18px] h-[18px] rounded-full bg-accent-50 dark:bg-accent-700 text-10px text-accent-300 flex justify-center items-center leading-0 ${
            active === "All"
              ? "text-primary-500 bg-primary-50 dark:bg-accent-600"
              : ""
          }
          }`}
        >
          {all || 0}
        </span>
      </div>
      <div
        onClick={() => setActiveTab("Active")}
        className={`cursor-pointer px-1 pb-10px flex items-center gap-8px 
  ${
    active === "Active"
      ? "text-primary-500 border-b-[3px] border-primary-500"
      : "dark:text-accent-300"
  }`}
      >
        Active{" "}
        <span
          className={`w-[18px] h-[18px] rounded-full bg-accent-50 dark:bg-accent-700 text-10px text-accent-300 flex justify-center items-center leading-0 ${
            active === "Active"
              ? "text-primary-500 bg-primary-50 dark:bg-accent-600"
              : ""
          }`}
        >
          {a || 0}
        </span>
      </div>
      <div
        onClick={() => setActiveTab("Disable")}
        className={`cursor-pointer px-1 pb-10px flex items-center gap-8px  ${
          active === "Disable"
            ? "text-primary-500 border-b-[3px] border-primary-500 "
            : "dark:text-accent-300"
        }`}
      >
        Disable{" "}
        <span
          className={`w-[18px] h-[18px] rounded-full bg-accent-50 dark:bg-accent-700 text-10px text-accent-300 flex justify-center items-center leading-0 ${
            active === "Disable"
              ? "text-primary-500 bg-primary-50 dark:bg-accent-600"
              : ""
          }}`}
        >
          {d || 0}
        </span>
      </div>
    </div>
  );
};

export default LinksFilterTabs;
